import {
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { OrgBusinessUnit } from '../../org-business-units/org-business-unit.model';

@Component({
    selector: 'topo-business-units-display',
    templateUrl: './business-units-display.component.html',
    styleUrls: ['./business-units-display.component.scss'],
    standalone: false
})
export class BusinessUnitsDisplayComponent {
  @Input() set businessUnits(value: OrgBusinessUnit[]) {
    this._businessUnits = value;
    this.hasBusinessUnits = value?.length > 0;
    if (!!this._businessUnits && !!this._selectedUIds) {
      this.loadTreeSelectedDisplay();
    }
  }

  @Input() set selectedUIds(value: string[]) {
    this._selectedUIds = value;
    if (!!this._businessUnits && !!this._selectedUIds) {
      this.loadTreeSelectedDisplay();
    }
  }

  @Input() multiSelectionMode: boolean;
  @Input() readonly: boolean;
  @Input() flowMode: boolean;
  @Output() activated = new EventEmitter();

  private _businessUnits: OrgBusinessUnit[];
  private _selectedUIds: string[];
  selectedDisplays: string[];
  selectedDisplayHints: string[];
  selectedDisplayActive: boolean[];
  hasBusinessUnits: boolean;

  private loadTreeSelectedDisplay(): void {
    this.selectedDisplays = [];
    this.selectedDisplayHints = [];
    this.selectedDisplayActive = [];
      this._selectedUIds?.forEach(id => {
        const selectedUnit = this._businessUnits.find(u => u.uId === id);
        if (!!selectedUnit) {
          this.selectedDisplays.push(selectedUnit.name);
          let searchUId = selectedUnit.uId;
          const pathToRoot = [];
          const foundParents = [];
          do {
            const searchUnit = this._businessUnits.find(u => u.uId === searchUId);
            if (!!searchUnit) {
              pathToRoot.push(searchUnit.name);
            }
            searchUId = searchUnit?.parentUId;
            if (!!searchUId && !foundParents.includes(searchUId)) {
                foundParents.push(searchUId);
            }
            else {
              searchUId = null;
            }
          } while (!!searchUId);
          pathToRoot.reverse();
          this.selectedDisplayHints.push(pathToRoot.join(' / '));
          this.selectedDisplayActive.push(selectedUnit.userHasNoAccess !== true);
        }
      })
  }

  activate(): void {
    if (!this.readonly && this._businessUnits?.length) {
      this.activated.emit();
    }
  }
}
